import React from 'react';
import { parse as parseQueryString } from 'qs';

import Subscribe from 'src/components/Subscribe';

import Login from 'src/pages/Login';
import PasswordForgot from 'src/pages/PasswordForgot';
import PasswordReset from 'src/pages/PasswordReset';
import Profile from 'src/pages/Profile';
import Jobs from 'src/pages/Jobs';
import Job from 'src/pages/Jobs/view';
import JobStats from 'src/pages/Jobs/stats';
import Stages from 'src/pages/Stages';
import Stats from 'src/pages/Stats';

import app from 'src/feathers';

export const BaseRoute = ({ component: Component, ...props }) => {
  props.location.query = parseQueryString(props.location.search, {
    ignoreQueryPrefix: true,
    strictNullHandling: true
  });
  return <Component {...props} />;
};

class PreppedRoute extends React.PureComponent {
  async componentDidMount() {
    // Do not destructure authentication and prepped from props
    // because they change as the authenticate() and prep()
    // methods are called.
    const { location } = this.props;
    const redirect =
      location.pathname === '/' || location.pathname === '/not-found'
        ? null
        : location.pathname;
    if (!this.props.authenticated) {
      await app.authenticate().catch(() => app.cleanup(redirect));
    }
    if (this.props.authenticated && !this.props.prepped) {
      await app.prep().catch(() => app.cleanup(redirect));
    }
  }
  render() {
    const { prepped } = this.props;
    if (!prepped) {
      return null;
    }
    // const { component: Component, ...rest } = this.props;
    // return (
    //   <Route
    //     {...rest}
    //     render={props => {
    //       return (
    //         <React.Fragment>
    //           <Header {...props} />
    //           <Component {...props} />
    //         </React.Fragment>
    //       );
    //     }}
    //   />
    // );
    return (
      <React.Fragment>
        {/* <SideMenu {...this.props} /> */}
        <BaseRoute {...this.props} />
      </React.Fragment>
    );
  }
}

export const PrivateRoute = (props) => (
  <Subscribe
    render={({ state }) => {
      const { authenticated, prepped } = state;
      return (
        <PreppedRoute
          {...props}
          authenticated={authenticated}
          prepped={prepped}
        />
      );
    }}
  />
);

// Pages that render the same page component with subroutes should have the
// same key, otherwise Switch will remount the component instead of rerendering
// https://github.com/ReactTraining/react-router/issues/4578
export const privateRoutes = [
  {
    path: '/profile',
    component: (props) => <PrivateRoute {...props} component={Profile} />,
    key: 'Profile'
  },
  {
    path: '/jobs',
    component: (props) => <PrivateRoute {...props} component={Jobs} />,
    key: 'Jobs'
  },
  {
    path: '/job',
    component: (props) => <PrivateRoute {...props} component={Job} />,
    key: 'Job'
  },
  {
    path: '/jobs/:_id',
    component: (props) => <PrivateRoute {...props} component={Job} />,
    key: 'JobId'
  },
  {
    path: '/jobs/:_id/stages',
    component: (props) => <PrivateRoute {...props} component={Stages} />,
    key: 'Stages'
  },
  {
    path: '/jobs/:_id/stats',
    component: (props) => <PrivateRoute {...props} component={JobStats} />,
    key: 'JobStats'
  },
  {
    path: '/stats',
    component: (props) => <PrivateRoute {...props} component={Stats} />,
    key: 'Stats'
  }
];

export const publicRoutes = [
  {
    path: '/login',
    component: (props) => <BaseRoute {...props} component={Login} />,
    key: 'Login'
  },
  {
    path: '/forgot-password',
    component: (props) => <BaseRoute {...props} component={PasswordForgot} />,
    key: 'PasswordForgot'
  },
  {
    path: '/reset-password',
    component: (props) => <BaseRoute {...props} component={PasswordReset} />,
    key: 'PasswordReset'
  }
];
